module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lekGa"))).then(() => parcelRequire('1iHdE'));